import React, { useState } from 'react';
import '../Style/category.css';

export const CATEGORY_MATRIX = {
  Physical: ['Strength', 'Endurance', 'Mobility', 'Sport', 'Recovery'],
  Technical: ['Engineering', 'Building', 'Design', 'Data/AI', 'Security', 'Coding'],
  Intellectual: ['Reading', 'Study', 'Research', 'Languages', 'Philosophy'],
  Career: ['Projects', 'Networking', 'Leadership', 'Marketing', 'Operations'],
  Wealth: ['Budgeting', 'Investing', 'Savings', 'Real Estate', 'Side Hustle'],
  Creative: ['Music', 'Fine Art', 'Writing', 'Media', 'Performance'],
  Mental: ['Meditation', 'Journaling', 'Psychology', 'Deep Work', 'Digital Detox'],
  Vitality: ['Nutrition', 'Sleep', 'Biohacking', 'Hydration', 'Recovery'],
  Social: ['Family', 'Friends', 'Partnership', 'Community', 'Mentorship'],
  Home: ['Cleaning', 'Gardening', 'DIY/Repairs', 'Organizing', 'Cooking'],
  Discipline: ['Early Rise', 'Quitting', 'Cold Exposure', 'Routine', 'Fasting'],
  Adventure: ['Travel', 'Outdoors', 'Exploration', 'Survival', 'Vlogging'],
  Character: ['Faith', 'Volunteering', 'Ethics', 'Stoicism', 'Generosity'],
  Logistic: ['Admin/Email', 'Taxes', 'Planning', 'Maintenance', 'Errands'],
  Focus: ['Strategy', 'Time Mgmt', 'Minimalism', 'Prioritizing', 'Execution'],
  Dance: ['BreakDance', 'HipHop', 'Choreo', 'Other'],
};

// 1. The Small Tag shown on the Goal Card
export const GoalCategoryTag = ({ category, useCase }) => {
  if (!category) return null;
  return (
    <div className="goal-category-tag">
      {category} • {useCase}
    </div>
  );
};

// 2. The Full Selection Modal
export const GoalCategoryPickerModal = ({ isOpen, onClose, onSelect, currentCategory }) => {
  const [activeCat, setActiveCat] = useState(currentCategory || 'Physical');

  if (!isOpen) return null;

  return (
    <div className="picker-overlay" onClick={onClose}>
      <div className="picker-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="picker-header">
          <div>
            <h3>Select Specialty</h3>
            <span className="helper-text">How would you categorize this goal?</span>
          </div>
          <button className="close-picker-btn" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="picker-container">
          <div className="category-list">
            {Object.keys(CATEGORY_MATRIX).map((cat) => (
              <div
                key={cat}
                className={`category-item ${activeCat === cat ? 'active' : ''}`}
                onClick={() => setActiveCat(cat)}
              >
                {cat}
              </div>
            ))}
          </div>
          <div className="use-case-grid">
            {CATEGORY_MATRIX[activeCat].map((uc) => (
              <div
                key={uc}
                className="use-case-card"
                onClick={() => onSelect({ category: activeCat, useCase: uc })}
              >
                {uc}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
